import { useTranslation } from 'react-i18next';
import type { Question } from '../../types';
import { PREVIEW_PARTICIPANTS, PREVIEW_EMOJI } from '../../data';
import { EmojiFace, NoObsFace } from '../EmojiFace';

interface PreviewIndividualOptionsProps {
  q: Question;
}

export function PreviewIndividualOptions({ q }: PreviewIndividualOptionsProps) {
  const { t } = useTranslation();
  const person = PREVIEW_PARTICIPANTS[0];
  const remaining = PREVIEW_PARTICIPANTS.length - 1;
  const opts = q.options.length > 0 ? q.options : [];

  const AnswerBody = () => {
    if (q.type === 'nps') return (
      <div className="pvx-ind-opt-nps">
        {Array.from({ length: 10 }, (_, i) => <span key={i}>{i + 1}</span>)}
      </div>
    );
    if (q.type === 'open') return (
      <div style={{ background: 'white', borderRadius: 8, border: '1.5px solid rgba(0,0,0,0.08)', padding: '10px 12px', fontSize: '0.8rem', color: '#9ca3af', fontStyle: 'italic' }}>
        {t('admin.builderPreviewWriteAnswer')}
      </div>
    );
    if (q.type === 'multiple') return (
      <div className="pvx-ind-mc">
        {opts.length > 0
          ? opts.map((opt, oi) => (
              <div key={oi} className="pvx-ind-mc-opt">
                <span className="pvx-dot" />
                <span style={{ fontSize: '0.8rem' }}>{opt}</span>
              </div>
            ))
          : (
              <>
                <div className="pvx-ind-mc-opt"><span className="pvx-dot" /><span style={{ fontSize: '0.8rem', color: '#9ca3af' }}>{t('admin.builderPreviewOption1')}</span></div>
                <div className="pvx-ind-mc-opt"><span className="pvx-dot" /><span style={{ fontSize: '0.8rem', color: '#9ca3af' }}>{t('admin.builderPreviewOption2')}</span></div>
              </>
            )
        }
        <div className="pvx-ind-mc-opt" style={{ opacity: 0.45, fontStyle: 'italic', fontSize: '0.8rem' }}>
          <span className="pvx-dot" /> {t('admin.builderPreviewNoObs')}
        </div>
      </div>
    );
    return (
      <div className="pvx-ind-opts">
        {PREVIEW_EMOJI.map(e => (
          <div key={e.label} className="pvx-ind-opt">
            <EmojiFace {...e} />
            <span>{e.label}</span>
          </div>
        ))}
        <div className="pvx-ind-opt"><NoObsFace /><span>{t('admin.builderPreviewNA')}</span></div>
      </div>
    );
  };

  if (!person) return null;

  return (
    <>
      <div className="pvx-ind-card">
        <div className="pvx-ind-person">
          <span className="pvx-avatar" style={{ width: 36, height: 36, fontSize: '0.7rem' }}>{person.initials}</span>
          <span className="pvx-name" style={{ fontSize: '0.9rem', fontWeight: 600 }}>{person.name}</span>
        </div>
        <AnswerBody />
      </div>
      {remaining > 0 && (
        <div className="pvx-ind-more">+{remaining} {t('admin.builderPreviewMorePersons')}</div>
      )}
    </>
  );
}
